import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { addReturnCostPayersApi, deleteReturnCostPayersApi, getReturnCostPayersApi, updateReturnCostPayersApi } from "../../../services/partners/settings/returnCostPayerService";


export const getAllReturnCostPayers = createAsyncThunk("partner/getAllReturnCostPayers", async (filters, { dispatch }) => {
  const response = await getReturnCostPayersApi(filters);
  return response.response;
});

export const addReturnCostPayers = createAsyncThunk("partner/addReturnCostPayers", async (duration, { dispatch, getState }) => {
  try {
    const response = await addReturnCostPayersApi(duration);
    const data = await response.response;
    toast.success("Add Partner Return Cost Payers successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const updateReturnCostPayers = createAsyncThunk("partner/updateReturnCostPayers", async (duration, { dispatch, getStatus }) => {
  try {
    const response = await updateReturnCostPayersApi(duration, duration.id);
    const data = await response.response;
    toast.success("Update Return Cost Slayers successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

export const deleteReturnCostPayers = createAsyncThunk("partner/deleteReturnCostPayers", async (id, { dispatch, getStatus }) => {
  try {
    const response = await deleteReturnCostPayersApi(id);
    const data = await response.response;
    toast.success("Deleted Return Cost Payers successfully", {
      position: toast.POSITION.TOP_RIGHT,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
});

const partnersReturnCostPayersAdapter = createEntityAdapter({});

export const { selectAll: selectReturnCostPayers, selectById: selectReturnCostPayersId } = partnersReturnCostPayersAdapter.getSelectors(
  (state) => state.partner.partnerReturnCostPayers
);

const partnerReturnCostPayersSlice = createSlice({
  name: "partnerReturnCostPayers",
  initialState: partnersReturnCostPayersAdapter.getInitialState({
    searchText: "",
    addDialog: {
      component: "PartnerReturnCostPayers",
      type: "new",
      props: {
        open: false,
      },
      data: null,
    },
  }),
  reducers: {
    setPartnerReturnCostPayersSearchText: {
      reducer: (state, action) => {
        state.searchText = action.payload;
      },
      prepare: (event) => ({ payload: event.target.value || "" }),
    },
    openNewDialog: (state, action) => {
      state.addDialog = {
        component: "PartnerReturnCostPayers",
        type: "new",
        props: {
          isOpen: true,
        },
        data: null,
      };
    },
    openEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: true,
        },
        data: action.payload,
      };
    },
    closeEditDialog: (state, action) => {
      state.addDialog = {
        type: "edit",
        props: {
          isOpen: false,
        },
        data: null,
      };
    },
  },
  extraReducers: {
    [getAllReturnCostPayers.fulfilled]: partnersReturnCostPayersAdapter.setAll,
  },
});

export const { setPartnerReturnCostPayersSearchText, openNewDialog, closeNewDialog, openEditDialog, closeEditDialog } = partnerReturnCostPayersSlice.actions;

export default partnerReturnCostPayersSlice.reducer;
